import { ApiError } from '../errors/api-error.js';

export class DetailedReportingService {
    constructor(api) { this.api = api; }

    async #call(operation) {
        try {
            const response = await operation();
            return { success: response.success ?? true, data: response.data ?? response, message: response.message };
        } catch (error) {
            throw error instanceof ApiError ? error : new ApiError(error.message || 'Detailed reporting request failed');
        }
    }

    generate(data) { return this.#call(() => this.api.generate(data)); }
    getAiConfiguration(reportKey) { return this.#call(() => this.api.getAiConfiguration(reportKey)); }
    listSnapshots(reportKey) { return this.#call(() => this.api.listSnapshots(reportKey)); }
    compareSnapshots(baselineId, targetId) { return this.#call(() => this.api.compareSnapshots(baselineId, targetId)); }
    createComparisonSession(baselineId, targetId, data) { return this.#call(() => this.api.createComparisonSession(baselineId, targetId, data)); }
    deleteSnapshot(id) { return this.#call(() => this.api.deleteSnapshot(id)); }
    listJobs() { return this.#call(() => this.api.listJobs()); }
    createJob(data) { return this.#call(() => this.api.createJob(data)); }
    updateJob(id, data) { return this.#call(() => this.api.updateJob(id, data)); }
    runJob(id) { return this.#call(() => this.api.runJob(id)); }
    listArchives(reportKey) { return this.#call(() => this.api.listArchives(reportKey)); }
    createDownloadLink(id) { return this.#call(() => this.api.createDownloadLink(id)); }
    downloadArchive(id, token) { return this.#call(() => this.api.downloadArchive(id, token)); }
    updateLifecycle(id, data) { return this.#call(() => this.api.updateLifecycle(id, data)); }
    listNarratives(snapshotId) { return this.#call(() => this.api.listNarratives(snapshotId)); }
    generateNarrative(data) { return this.#call(() => this.api.generateNarrative(data)); }
    regenerateNarrative(id) { return this.#call(() => this.api.regenerateNarrative(id)); }
    updateNarrative(id, data) { return this.#call(() => this.api.updateNarrative(id, data)); }
    deleteNarrative(id) { return this.#call(() => this.api.deleteNarrative(id)); }
}
